import { useMeetingContext } from './Peek.jsx';

// What stands out on a page.
//
// Each item is a rule's reading of this household, worded by the selector
// that found it, so nothing here needs an advisor to write. What an advisor
// does get is the last word: with Adjust on, every item shows a quiet "leave
// out", and anything left out is listed beside the slide where one click
// brings it back. The choice is saved with the assessment, so the meeting and
// the takeaway agree on what was said.
//
// Nothing is dressed as a conclusion. Every entry carries its own figure and
// says what it rests on, which is the difference between pointing something
// out and giving the plan away.

// `brief` shows the headings alone, for a page where the picture does the
// explaining; each heading is then worded to stand on its own.
export default function Callouts({ items = [], title = 'What stands out', columns = 1, brief = false }) {
  const { adjustable, adjusting, hide } = useMeetingContext();
  const editing = adjustable && adjusting;
  const shown = items.filter(i => !i.hidden);
  if (!shown.length) return null;

  return (
    <section className={`conv-callouts${columns === 2 ? ' is-two' : columns > 2 ? ' is-three' : ''}`} aria-label={title}>
      <div className="conv-eyebrow">{title}</div>
      <ul>
        {shown.map(i => (
          <li key={i.key} data-tone={i.tone}>
            <div>
              <strong>{i.headline}</strong>
              {i.detail && !brief ? <span>{i.detail}</span> : null}
            </div>
            {editing ? (
              <button type="button" className="conv-link conv-callout-hide" onClick={() => hide(i.key)}>
                Leave out
              </button>
            ) : null}
          </li>
        ))}
      </ul>
    </section>
  );
}
